// @ts-nocheck
import React, { useEffect, useRef, useState } from "react";
import style from "./OutputForm.module.scss";
import { getImageUrl } from "../../../../commons/assets_path";
import { DirectUpload } from "@rails/activestorage";
import { useTranslation } from "react-i18next";

type Props = {
  label: object[];
  i: number;
  iconPath: string;
  isDisplayNameEditable: boolean;
  isTestValueEditable: boolean;
  template_class_name: string;
  direct_upload_url: string;
};

export const MailOutputLabel = ({
  label,
  i,
  iconPath,
  isDisplayNameEditable,
  isTestValueEditable,
  template_class_name,
  direct_upload_url,
}: Props) => {
  const { t } = useTranslation();
  const [labelValue, setLabelValue] = useState(label);
  const [editValue, setEditValue] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const fileInputRef = useRef(null);
  const titleRef = useRef(null);
  const valueRef = useRef(null);
  const editLabel = () => {
    setEditValue(labelValue);
    setShowModal(true);
  };
  const submit = () => {
    setLabelValue(editValue);
    setShowModal(false);
  };

  useEffect(() => {
    if (editValue?.test_value) {
      const _copy = editValue.test_value.replace(/\n/g, " ");
      setEditValue((prevState) => ({ ...prevState, test_value: _copy }));
    }
    if (showModal) {
      document.getElementsByName("set_trigger")[0].disabled = true;
    } else {
      document.getElementsByName("set_trigger")[0].disabled = false;
    }
  }, [showModal]);

  const createUploadPromise = (upload) => {
    return new Promise((resolve, reject) => {
      upload.create((error, blob) => {
        if (error) {
          reject(error);
        } else {
          resolve(blob);
        }
      });
    });
  };

  return (
    <div style={{ position: "relative", width: "100%" }}>
      <div
        className={`${style.outputLabelWrap} js-trigger-output- js-workflow_template_action_output_text_field`}
        style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", position: "relative" }}
        onMouseOver={() => setShowEdit(true)}
        onMouseLeave={() => setShowEdit(false)}
      >
        <img className={style.outputLabelIcon} src={getImageUrl(`images/icons/${iconPath}.svg`)}></img>
        <div className={`${style.outputLabelTitle} test_output_label_display_name`} ref={titleRef}>
          {labelValue.display_name}
        </div>
        <input
          className="form-control js-display_name_for_output_duplication_check"
          data-target-id={label.target_id}
          value={labelValue.display_name}
          type="hidden"
          name={`${template_class_name}[workflow_template_action_attributes][workflow_template_action_outputs_attributes][${i}][display_name]`}
          id={`${template_class_name}_workflow_template_action_attributes_workflow_template_action_outputs_attributes_${i}_display_name`}
        />
        <>
          {label.data_type === "long_text" || label.data_type === "array" ? (
            <textarea
              className="form-control"
              data-target-id={label.target_id}
              value={labelValue.test_value.replace(/\\n/g, "\n")}
              style={{ display: "none" }}
              name={`${template_class_name}[workflow_template_attributes][workflow_template_action_outputs_attributes][${i}][test_value]`}
              id={`${template_class_name}_workflow_template_attributes_workflow_template_action_outputs_attributes_${i}_test_value`}
            />
          ) : (
            <>
              <input
                className="form-control"
                data-target-id={label.target_id}
                value={labelValue.test_value}
                type="hidden"
                name={`${template_class_name}[workflow_template_attributes][workflow_template_action_outputs_attributes][${i}][test_value]`}
                id={`${template_class_name}_workflow_template_attributes_workflow_template_action_outputs_attributes_${i}_test_value`}
              />
              {label.data_type === "file" && labelValue.output_test_attachment_file && (
                <input
                  className="form-control"
                  data-target-id={label.target_id}
                  value={labelValue.output_test_attachment_file || null}
                  type="hidden"
                  name={`${template_class_name}[workflow_template_attributes][workflow_template_action_outputs_attributes][${i}][output_test_attachment_file]`}
                  id={`${template_class_name}_workflow_template_attributes_workflow_template_action_outputs_attributes_${i}_output_test_attachment_file`}
                />
              )}
            </>
          )}
          <input
            className="form-control"
            data-target-id={label.target_id}
            value={labelValue?.target_id}
            type="hidden"
            name={`${template_class_name}[workflow_template_attributes][workflow_template_action_outputs_attributes][${i}][id]`}
            id={`${template_class_name}_workflow_template_attributes_workflow_template_action_outputs_attributes_${i}_id`}
          />
        </>

        <div
          className={`${style.outputLabelValue} test_output_label_test_value`}
          ref={valueRef}
          dangerouslySetInnerHTML={{ __html: labelValue.test_value.replace(/\\n/g, " ") }}
        />

        {(isDisplayNameEditable || isTestValueEditable) && showEdit && (
          <img
            src={getImageUrl("images/icons/editGray.svg")}
            style={{ cursor: "pointer" }}
            onClick={() => {
              editLabel();
            }}
          />
        )}
      </div>
      {showModal && (
        <div className={style.outputEditModal}>
          <div className={style.outputEditContent}>
            <div className={style.outputEditRow}>
              <div className={style.outputEditElement}>
                <div className={style.outputEditTitle}>{t("MailOutputLabel.項目名")}</div>
                <input
                  className={`${style.outputEditInput} js-display_name_for_output_duplication_check`}
                  value={editValue.display_name}
                  readOnly={!isDisplayNameEditable}
                  style={{
                    color: !isDisplayNameEditable && "#777777",
                    backgroundColor: !isDisplayNameEditable && "#F3F3F3",
                  }}
                  onChange={(e) => {
                    const _copy = JSON.parse(JSON.stringify(editValue));
                    _copy.display_name = e.target.value;
                    setEditValue(_copy);
                  }}
                ></input>
              </div>
              <div className={style.outputEditElement}>
                {label.data_type === "file" ? (
                  <>
                    <div className={style.outputEditTitle}>{t("MailOutputLabel.添付ファイル")}</div>
                    <div className={style.outputEditElement} onClick={() => fileInputRef.current.click()}>
                      <div className={style.outputEditInput} style={{ cursor: "pointer" }}>
                        {editValue.test_value || t("MailOutputLabel.ファイルを選択")}
                      </div>
                      <input
                        ref={fileInputRef}
                        type="file"
                        style={{ display: "none" }}
                        onChange={async (e) => {
                          const _copy = JSON.parse(JSON.stringify(editValue));
                          const file = e.target.files[0];
                          const upload = new DirectUpload(file, direct_upload_url);
                          try {
                            const blob = await createUploadPromise(upload);
                            _copy.test_value = file.name;
                            _copy.output_test_attachment_file = blob.signed_id;
                            setEditValue(_copy);
                          } catch (error) {
                            // 何もしない
                          }
                        }}
                        data-direct-upload-url={direct_upload_url}
                      />
                    </div>
                  </>
                ) : label.data_type === "text" ? (
                  <>
                    <div className={style.outputEditTitle}>{t("MailOutputLabel.テストで取得した値")}</div>
                    <input
                      className={style.outputEditInput}
                      readOnly={!isTestValueEditable}
                      style={{
                        color: !isTestValueEditable && "#777777",
                        backgroundColor: !isTestValueEditable && "#F3F3F3",
                      }}
                      value={editValue.test_value}
                      onChange={(e) => {
                        const _copy = JSON.parse(JSON.stringify(editValue));
                        _copy.test_value = e.target.value;
                        setEditValue(_copy);
                      }}
                    />
                  </>
                ) : (
                  <>
                    <div className={style.outputEditTitle}>{t("MailOutputLabel.テストで取得した値")}</div>
                    <textarea
                      className={style.outputEditInput}
                      readOnly={!isTestValueEditable}
                      style={{
                        color: !isTestValueEditable && "#777777",
                        backgroundColor: !isTestValueEditable && "#F3F3F3",
                      }}
                      value={editValue.test_value.replace(/\\n/g, "\n")}
                      onChange={(e) => {
                        const _copy = JSON.parse(JSON.stringify(editValue));
                        _copy.test_value = e.target.value;
                        setEditValue(_copy);
                      }}
                    />
                  </>
                )}
              </div>
            </div>
          </div>
          <div className={style.outputEditButtonRow}>
            <div
              className="btn btn-secondary"
              style={{ fontSize: "16px", padding: "6px", height: "44px" }}
              onClick={() => {
                setShowModal(false);
              }}
            >
              {t("MailOutputLabel.キャンセル")}
            </div>
            <button
              className="btn btn-info test_save_output_btn"
              style={{
                fontSize: "16px",
                padding: "6px",
                height: "44px",
              }}
              // 取得した値の項目名がない場合とファイルのアップロードが完了していない場合は保存できないようにする。
              disabled={
                !editValue.display_name ||
                (label.data_type === "file" &&
                  editValue.output_test_attachment_file === labelValue.output_test_attachment_file)
              }
              onClick={() => {
                submit();
              }}
            >
              {t("MailOutputLabel.保存")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
